import { formatters } from '@nexelem/utils';

export const parseValueToPrice = (price: number, valueSuffix?: string, currency?: string, displayStyle?: boolean) => {
  if (displayStyle) {
    return formatters.number.format(price || 0, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  } else {
    if (currency) {
      const parsedPrice = formatters.number.format(price);
      return `${parsedPrice} ${currency} ${valueSuffix}`;
    } else {
      return '-';
    }
  }
};
